import React, { forwardRef, type CSSProperties, type ReactNode } from "react";
import classNames from "classnames";
import "./builderToolbar.scss";

interface IBuilderToolbarMenuPanelProps {
  open: boolean;
  panelWidth: number;
  slideTranslateExtra?: number;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  role?: string;
  "aria-label"?: string;
  "aria-hidden"?: boolean;
  inertWhenClosed?: boolean;
}

export const BuilderToolbarMenuPanel = forwardRef<HTMLDivElement, IBuilderToolbarMenuPanelProps>((props, ref) => {
    const {
      open,
      panelWidth,
      slideTranslateExtra = 10,
      className,
      style,
      children,
      role,
      "aria-label": ariaLabel,
      "aria-hidden": ariaHidden,
      inertWhenClosed,
    } = props;

    const panelStyle = {
      ...style,
      "--builder-menu-panel-width": `${panelWidth}px`,
      "--builder-menu-panel-slide-offset": `${panelWidth + slideTranslateExtra}px`,
    } as CSSProperties;

    return (
      <div
        ref={element => {
          if (typeof ref === "function") {
            ref(element);
          } else if (ref) {
            ref.current = element;
          }

          if (element === null || !inertWhenClosed) {
            return;
          }

          if (!open) {
            element.setAttribute("inert", "");
            return;
          }

          element.removeAttribute("inert");
        }}
        className={classNames("builder-toolbar-menu-panel", className, {
          open,
          closed: !open,
        })}
        style={panelStyle}
        role={role}
        aria-label={ariaLabel}
        aria-hidden={ariaHidden}
      >
        {children}
      </div>
    );
});
BuilderToolbarMenuPanel.displayName = "BuilderToolbarMenuPanel";
